import React from 'react';
import { DivMain, Btn, Conteiner, Form } from '../../components/Conteiner';
import Logo from '../../img/Logo.png';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup"
import { MenuItem, TextField } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { useState } from 'react';
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';

interface IDataCadastro{
  name: string;
  email: string;
  password: string;
  contact:string;
  bio: string;
  course_module: string;
  confirSenha: string;
}




function Cadastro() {
  const [isCadastro , setIsCadastro] = useState<boolean|null>(null)
  const navigate = useNavigate();


    const formSchema = yup.object().shape({
      name: yup.string().required('Nome obrigatório').min(3, 'Deve ter mais de 3 caracteres'),
      email: yup.string().email("Coloque um email valido").required('Email obrigatório'),
      password: yup.string().required("Senha Obrigatoria").matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z$*&@#]{8,}$/, 
      "Senha deve ter 8 caracteres no mínimo,1 Letra Maiúscula no mínimo,1 Número no mínimo e 1 e nao pode ter sequencias"),
      confirSenha: yup.string().oneOf([yup.ref("password")], "Senhas devem ser igual"),
      contact: yup.string().required('Telefone obrigatório'),
      bio: yup.string().required('Fale sobre você'),
      course_module: yup.string().required('Selecione um modulo')
    });

  const { register, handleSubmit, formState:{ errors } } = useForm<IDataCadastro>({
    resolver:yupResolver(formSchema)
  })

  const currencies =[
    {
      value : "Primeiro modulo",
      label : "Primeiro modulo"
    },
    {
      value : "Segundo modulo",
      label : "Segundo modulo"
    },    {
      value : "Terceiro modulo",
      label : "Terceiro modulo"
    },    {
      value : "Quarto modulo",
      label : "Quarto modulo"
    },    {
      value : "Quinto modulo",
      label : "Quinto modulo"
    },
  ];
  useEffect(()=>{
    if(isCadastro){
      try {
        toast.success("Cadastro realizado com sucesso, por favor o login")
        setTimeout(()=>{navigate("/login", {replace: true})},4000) 
        
      } catch (error) {
        
      }
    }
  },[isCadastro, navigate])

  const handleForm = async (data:IDataCadastro)=>{
    await api.post('/users', data)
    .then((response)=>{
      console.log(response)
      setIsCadastro(true)
    })
    .catch((err)=>console.log(err));
  }

  return (
    <>
    <ToastContainer
    position="top-right"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick={false}
    rtl={false}
    pauseOnFocusLoss={false}
    draggable={false}
    pauseOnHover/>
  <DivMain>
    <header>
      <img className='logo-cadastro' src={Logo} alt="logo kenzieHub" />
      <Link className='linkVoltar' to="/">Voltar</Link>
    </header>
      
    <Conteiner> 
      <h1>Crie sua conta</h1>
      <span>Rapido e grátis, vamos nessa</span>
      <Form className='form' onSubmit={handleSubmit(handleForm)}>
        <TextField required error={ !!errors.name} placeholder="Digite seu nome"
        helperText={errors?.name?.message} label="name"  
        {...register("name")}>
        </TextField>

        <TextField required error={!!errors.email} placeholder="Digite seu email"
        helperText={errors?.email?.message} label="email"  
        {...register("email")}>
        </TextField>
    
        <TextField type='password' required error={!!errors.password} placeholder="Digite sua senha"
        helperText={errors?.password?.message} label="Senha"  
        {...register("password")}>
        </TextField>

        <TextField type='password' required error={!!errors.confirSenha} 
        placeholder="Digite novamente sua senha"
        helperText={errors?.confirSenha?.message} label="Confirmar Senha"  
        >
        </TextField>

        <TextField required error={!!errors.contact} placeholder="Opção de contato" 
        helperText={errors?.contact?.message}label="contact"  
        {...register("contact")}>
        </TextField>
  
        <TextField type='text' required error={!!errors.bio} 
        helperText={errors?.bio?.message} label="bio" 
        placeholder='Conte sobre você' 
        {...register("bio")}>
        </TextField>

        <TextField className='inputSelectModule' label='Selecione o modulo' select 
        required error={!!errors.course_module} helperText={errors?.course_module?.message}
        {...register("course_module")}>
          {currencies.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}</TextField>
        <Btn color={`#59323F`} type='submit'>Cadastrar</Btn>
      </Form>
    </Conteiner>
  </DivMain>
  </>
  );
}

export default Cadastro;